exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table th{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}", ""]);

// exports
